import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, CreateEntityResponse, IMAGES } from '@/core';

export const useImage = () => {
  const queryUrl = `${ADMIN_API_URL_SUBPATH}/${IMAGES}`;

  const createImageMutation: UseMutationResult<
    AxiosResponse<CreateEntityResponse>,
    unknown,
    FormData,
    unknown
  > = useMutation({
    mutationKey: ['createImage'],
    mutationFn: (data: FormData) =>
      axiosInstance.post(`${queryUrl}/upload`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  });

  const deleteImageMutation = useMutation({
    mutationKey: ['deleteImage'],
    mutationFn: (id: number) => axiosInstance.delete(`${queryUrl}/${id}`),
  });

  return {
    mutations: {
      createImageMutation,
      deleteImageMutation,
    },
  };
};
